export default {"src":"/_next/static/media/ecm-lz-rebranding.39194e47.svg","height":218,"width":250};